import { State } from 'src/types'
import { thumbOut } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/thumbAndListBelt'
import { thumbIndexMiddleFinger } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/thumbIndexMiddleFinger'
import { middleRingFinger } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/middleRingFinger'
import { ringLittleFinger } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/ringLittleFinger'
import { firstBackLittleFinger } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/littleFinger'
import { indexFingerPad } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/fingerCoverOrPad/indexFingerPad'
import { edgeOfWrist } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/edge/edgeOfWrist'
import { hamidashiOfFirstBack } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/hamidashi/firstBack'
import { fingerHole } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/fingerHole'
import { firstBackStyleWristBelt } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/firstBackStyleWristBelt'
import { thumbEmbroideryDrawer } from 'src/features/brands/atoms/canvas/common/back/useCanvasEmbroideries'
import { thumbHook } from '../hooks/thumbHook'

// ファーストバック モデル
export const firstBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (state.backStyle?.value !== 'firstBackStyle' && state?.baseModel?.backStyle !== 'firstBackStyle') return
  const isFingerPad = ['indexPad'].includes(state.fingerGuardType.value)
  // 親指外
  thumbOut(ctx, state.thumbOut.color)
  // 親指内_人差し指_中指右
  thumbIndexMiddleFinger(ctx, state.thumbIndexMiddle?.color)
  // 中指左_薬指右
  middleRingFinger(ctx, state.middleLeftRingRight?.color)
  // 薬指左_小指右
  ringLittleFinger(ctx, state.ringLeftLittleRight?.color)
  // 小指外
  firstBackLittleFinger(ctx, state.littleOut?.color)
  // ハミダシ
  hamidashiOfFirstBack(ctx, state.hamidashi.color)
  // ファーストバックベルト
  firstBackStyleWristBelt(ctx, state.listBelt.color)
  // 指当て
  isFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
  // 指穴実装
  fingerHole(ctx, state.linings.color, state.lace.color)
  // ヘリ革
  edgeOfWrist(ctx, state.edge.color, state.stitch.color)
  // 親指への刺繍
  thumbHook(ctx, state.thumbHook.color, 110, -310, 15) // 先端 // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color, -14, 30, 0) //手元
  thumbEmbroideryDrawer(ctx, state.embroideries)
}
